module.exports = __webpack_public_path__ + "img/question18c4.14a2ec68.png";